/*** IMPORTS FROM imports-loader ***/
var global = window;

// eslint-disable-next-line strict
module.exports = null;

